import React from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import styles from './CashierBonusAnalytics.module.css';
import cashierBonusApi from '../../../../store/analyticsStores/cashierBonusStore/cashierBonusApi';

export default function CashierBonusAnalytics({
    analytics,
    isLoading,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    branchId,
    onSelectCashier,
}) {
    const { t } = useTranslation();

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        return `${year}-${month}-${day}`;
    };

    const handleExport = () => {
        if (!branchId) return;
        let dates = '';
        if (startDate && endDate) {
            dates = `?from=${formatDate(startDate)}&to=${formatDate(endDate)}`;
        }
        cashierBonusApi.exportCashierBonusAnalytics(branchId, dates);
    };

    const handleClearDates = () => {
        setStartDate(null);
        setEndDate(null);
    };

    const totalTransactionAmount = analytics?.reduce((sum, item) => sum + (item.total_transaction_amount || 0), 0) || 0;
    const totalAmount = analytics?.reduce((sum, item) => sum + item.total_amount, 0) || 0;
    const totalCount = analytics?.reduce((sum, item) => sum + item.count, 0) || 0;

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>{t('NSCashierBonuses.title')}</h2>

            <div className={styles.datePickerRow}>
                <div className={styles.datePickers}>
                    <DatePicker
                        selected={startDate}
                        onChange={date => setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        dateFormat="dd.MM.yyyy"
                        placeholderText={t('from')}
                        className={styles.datePicker}
                    />
                    <span className={styles.dateSeparator}>—</span>
                    <DatePicker
                        selected={endDate}
                        onChange={date => setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        dateFormat="dd.MM.yyyy"
                        placeholderText={t('to')}
                        className={styles.datePicker}
                    />
                </div>
                {(startDate || endDate) && (
                    <button className={styles.clearButton} onClick={handleClearDates}>
                        {t('clear')}
                    </button>
                )}
                <button className={styles.exportButton} onClick={handleExport}>
                    {t('NSCashierBonuses.export')}
                </button>
            </div>

            {isLoading ? (
                <div className={styles.loading}>{t('loading')}...</div>
            ) : !analytics || analytics.length === 0 ? (
                <div className={styles.noData}>{t('NSCashierBonuses.noData')}</div>
            ) : (
                <div className={styles.tableCard}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{t('cashier')}</th>
                                <th>{t('NSCashierBonuses.phone')}</th>
                                <th>{t('NSCashierBonuses.role')}</th>
                                <th>{t('NSCashierBonuses.totalTransactionAmount')}</th>
                                <th>{t('NSCashierBonuses.totalAmount')}</th>
                                <th>{t('NSCashierBonuses.transactionCount')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {analytics.map((item, index) => (
                                <tr
                                    key={`${item.waiter_id || item.casher_phone}-${item.casher_role}-${index}`}
                                    className={styles.clickableRow}
                                    onClick={() => onSelectCashier(item)}
                                >
                                    <td>{index + 1}</td>
                                    <td>{item.casher_name || '-'}</td>
                                    <td>{item.casher_phone || '-'}</td>
                                    <td>
                                        {item.casher_role ? (
                                            <span className={styles.roleBadge} data-role={item.casher_role}>
                                                {t('roles.' + item.casher_role)}
                                            </span>
                                        ) : '-'}
                                    </td>
                                    <td>{Math.round(item.total_transaction_amount || 0).toLocaleString()}</td>
                                    <td>{Math.round(item.total_amount).toLocaleString()}</td>
                                    <td>{item.count}</td>
                                </tr>
                            ))}
                            <tr className={styles.totalRow}>
                                <td></td>
                                <td>{t('NSCashierBonuses.total')}</td>
                                <td></td>
                                <td></td>
                                <td>{Math.round(totalTransactionAmount).toLocaleString()}</td>
                                <td>{Math.round(totalAmount).toLocaleString()}</td>
                                <td>{totalCount}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
